import Tooltip from '@anm/components/Tooltip';
import { StyledCheckbox } from '@anm/components/form/Checkbox';
import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

type WrapperProps = {
  disabled: boolean;
};

export const ControlLabel = styled.label`
  width: max-content;
`;

const LabelTextOnMobiles = media.tablet`
  font-size: 14px;
`;

export const TooltipWrapper = styled(Tooltip)`
  min-width: 220px;
  left: 0;
  bottom: 30px;

  &:after {
    display: block;
    content: '';
    width: 100%;
    height: 10px;
    left: 0;
    position: absolute;
    top: 100%;
  }
`;

export const Wrapper = styled.div<WrapperProps>`
  cursor: pointer;
  position: relative;

  label {
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      label {
        pointer-events: none;

        ${StyledCheckbox} {
          background: #ebeef5;
          img {
            filter: brightness(65%) saturate(100%);
          }
        }
      }
    `}
`;

export const LabelText = styled.span`
  padding-left: 10px;
  user-select: none;
  cursor: pointer;
  ${LabelTextOnMobiles}
`;
